// actions
import * as actions from './actions';

const initialState = {
  // User orders list (authenticated)
  orders: [],
  ordersLoading: false,
  ordersError: null,
  ordersPagination: {
    count: 0,
    next: null,
    previous: null,
  },

  // Single order detail
  orderDetail: null,
  orderDetailLoading: false,
  orderDetailError: null,

  // Public order tracking
  trackedOrder: null,
  trackingLoading: false,
  trackingError: null,
};

export default function userOrdersReducer(state = initialState, action) {
  switch (action.type) {
    // FETCH USER ORDERS
    case actions.FETCH_USER_ORDERS.REQUEST:
      return { ...state, ordersLoading: true, ordersError: null };

    case actions.FETCH_USER_ORDERS.SUCCESS:
      return {
        ...state,
        ordersLoading: false,
        orders: action.payload.results || [],
        ordersPagination: {
          count: action.payload.count || 0,
          next: action.payload.next,
          previous: action.payload.previous,
        },
      };

    case actions.FETCH_USER_ORDERS.FAILURE:
      return { ...state, ordersLoading: false, ordersError: action.payload.error };

    // FETCH ORDER DETAIL
    case actions.FETCH_ORDER_DETAIL.REQUEST:
      return { ...state, orderDetailLoading: true, orderDetailError: null };

    case actions.FETCH_ORDER_DETAIL.SUCCESS:
      return { ...state, orderDetailLoading: false, orderDetail: action.payload };

    case actions.FETCH_ORDER_DETAIL.FAILURE:
      return { ...state, orderDetailLoading: false, orderDetailError: action.payload.error };

    // TRACK ORDER (public)
    case actions.TRACK_ORDER.REQUEST:
      return { ...state, trackingLoading: true, trackingError: null, trackedOrder: null };

    case actions.TRACK_ORDER.SUCCESS:
      return { ...state, trackingLoading: false, trackedOrder: action.payload };

    case actions.TRACK_ORDER.FAILURE:
      return { ...state, trackingLoading: false, trackingError: action.payload.error };

    // CLEAR TRACKING
    case actions.CLEAR_TRACKING:
      return { ...state, trackedOrder: null, trackingError: null };

    default:
      return state;
  }
}
